import { useContext, useState } from "react";
import { setPaso } from "../context/action/paso";
import { AutocheckContext } from "../context/Provider";
import { pasos } from "./Pasos/Pasos";

const AutocheckinPage = () => {
  // -------------------------  context ----------------------------
  const { pasoState, pasoDispatch } = useContext(AutocheckContext);
  // -------------------------  context ----------------------------

  // -------------------------  useStates ----------------------------
  const [msjLoading, setMsjLoading] = useState({
    message: "Cargando datos...",
  });
  const [error, setError] = useState({
    message: "Esta en un error",
    errorBack: "TurnosDelDia",
    atention: false,
  });
  const [turnoActual, setTurnoActual] = useState(0);
  const [pasoSelectFamiliar, setPasoSelectFamiliar] = useState(false); 
  // -------------------------  useStates ----------------------------

  // -------------------------  constants ----------------------------
  const Component = pasos[pasoState.paso.data];
  // const Component = pasos["TurnoRecepcionadoLabo"]; 
  // -------------------------  constants ----------------------------

  // -------------------------  funciones ----------------------------
  const setLoading = (msj) => {
    setMsjLoading({ message: msj });
    setPaso("Loading")(pasoDispatch);
  };
  // -------------------------  funciones ----------------------------

  return (
    <Component
      setLoading={setLoading}
      dataLoading={true}
      descripcion={msjLoading.message}
      color={"c-white"}
      setError={setError}
      errorMsg={error.message}
      errorBack={error.errorBack}
      errorCaution={error.atention}
      turnoActual={turnoActual}
      setTurnoActual={setTurnoActual}
      pasoSelectFamiliar={pasoSelectFamiliar} 
      setPasoSelectFamiliar={setPasoSelectFamiliar}
      pasoActual={pasoState.paso.data}
    />
  );
};

export default AutocheckinPage;
